import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const WmPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Wm}
        fetchRecordsUrl={AdminReqUrls.admin__wm__mainPage_fetch_recordList}
        showMultipleDelete={true}
    />)
});
export default WmPage;
